import React, { useEffect, useRef, useState } from 'react';
import { Tooltip, Typography } from '@mui/material';

const TruncateTooltip = ({ children, sx = {}, ...props }) => {
  const textRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setShowTooltip(el.scrollWidth > el.clientWidth);
    }
  }, [children]);

  return (
    <Tooltip title={children} arrow placement="top" disableHoverListener={!showTooltip} {...props}>
      <Typography
        ref={textRef}
        id={props.id}
        sx={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          maxWidth: '140px',
          ...sx
        }}
        {...props}
      >
        {children}
      </Typography>
    </Tooltip>
  );
};

export default TruncateTooltip;
